
  import React from "react"
  import Component from "/opt/render/project/src/src/layouts/index.tsx"
  import data from "/opt/render/project/src/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js